import { Route, Routes } from '@angular/router';
import { ERROR_ROUTES, NOT_FOUND_ROUTE } from '../../../v2/errors/error-routes';
// Three levels up, not two: this file is app/src/app/main/routing/routes/, so
// `../../` only gets as far as `main`. The v2 tree is a sibling of `main`.
import { v2EntitlementGuard } from '../../../v2/guards/v2-entitlement.guard';
import { AuthenticatedUserGuard, IsSuperAdminGuard } from '../../../auth/routing/guards';

/**
 * The old admin is retired (admin v2 parity plan, Task 26): every /admin/... page URL (bookmarks,
 * old e-mails) lands on the admin v2 overview, which IsSuperAdminGuard protects. The API host's Django
 * admin (/admin/ there) is a different app and is not affected.
 */
export const RETIRED_ADMIN_REDIRECT: Route = { path: 'admin', redirectTo: '/admin-v2/overview' };

/** Admin v2 (JFT staff), mounted here since the old admin module that held it was retired. */
export const ADMIN_V2_MOUNT: Route = {
    path: 'admin-v2',
    canActivate: [AuthenticatedUserGuard, IsSuperAdminGuard],
    loadChildren: () => import('../../../admin-v2/admin-v2.routes').then(m => m.ADMIN_V2_ROUTES),
};

export const appModuleRoutes: Routes = [
    {
        path: '',
        redirectTo: 'access',
        pathMatch: 'full'
    },
    // The error pages (/error/:kind, and the old /maintenance-mode and /service-unavailable).
    ...ERROR_ROUTES,
    // Must stay ahead of the '**' wildcard below, which would otherwise
    // swallow /v2 and render Not Found. canMatch, not canActivate: an
    // unentitled user never fetches the chunk.
    {
        path: 'v2',
        canMatch: [v2EntitlementGuard],
        loadChildren: () => import('../../../v2/v2.routes').then(m => m.v2Routes)
    },
    ADMIN_V2_MOUNT,
    RETIRED_ADMIN_REDIRECT,
    // Page Not Found: inside the v2 shell for a signed-in v2 user, else the minimal page.
    NOT_FOUND_ROUTE,
];
